/**
 * AliSave Plus — AliExpress image downloader
 *
 * A single web-accessible-resource group exposes a fixed list of five PNGs — the
 * toolbar icon set plus images/icon32_review_images.png — to every origin, with no
 * use_dynamic_url. Each sits at a stable URL and loads through an <img> with no CORS
 * grant, so detection survives a restrictive page CSP.
 *
 * Manifest verified against version 3.0.26.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ppfoibjbcchcfifclhebkhnigneiceje';

export const aliSavePlus: ExtensionDefinition = {
  id: ID,
  name: 'AliSave Plus - Download AliExpress Images',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Five static PNGs exposed to every origin with no dynamic URL. All load without a ' +
    'CORS grant, so identification is conclusive and CSP-proof.',
  signals: [
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load icons/icon128.png via <img> — exposed to every origin and readable without ' +
        'a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'icons/icon128.png'),
    },
    {
      id: 'war-review-images-icon',
      kind: 'web-accessible-resource',
      description:
        'Load images/icon32_review_images.png via <img> — a distinctively named feature ' +
        'icon, corroborating independently of the toolbar set.',
      weight: 0.5,
      run: () => probeImage(ID, 'images/icon32_review_images.png'),
    },
    {
      id: 'war-icon-48',
      kind: 'web-accessible-resource',
      description: 'Load icons/icon48.png via <img> — a third image path.',
      weight: 0.5,
      run: () => probeImage(ID, 'icons/icon48.png'),
    },
  ],
};
